import * as React from "react";
import {
  Col,
  Form,
  Icon,
  Input,
  Row,
  Select,
  Tooltip,
  InputNumber
} from "antd";
import { createRequest, fetchItemRequest, updateRequest } from "@actions/city";
import { City, CityType } from "@models/city";
import { SelectionMode } from "@models/index";
import { FormattedMessage } from "react-intl";
import PovinceSingleSelection from "@components/provinces/selection/SingleSelection";
import { Province } from "@models/province";
import withFormWrapper from "../../hocs/withFormWrapper";

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  city?: City;
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
  fetchItemRequest: typeof fetchItemRequest;
}

type CityFormAllProps = PropsFromState & PropsFromDispatch;

type CityFormStateShape = {
  visible: boolean;
  name: string;
  province: Province | null;
  type: CityType;
  id: string | null;
};

class CityForm extends React.Component<CityFormAllProps, CityFormStateShape> {
  constructor(props) {
    super(props);
    const { city } = props;
    this.state = {
      visible: false,
      ...this.getStateFormProps(city)
    };
  }

  getStateFormProps = (city: City | null) => {
    const obj = city || {};
    return {
      name: obj.name || "",
      id: obj.id,
      province: obj.province
    };
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.city &&
      !prevProps.city.is_fetched &&
      this.props.city.is_fetched
    ) {
      this.setState({
        ...this.getStateFormProps(this.props.city)
      });
    }
  }

  getValues = () => {
    let returnValues = null;
    this.props.form.setFieldsValue({
      province_id: this.state.province ? this.state.province.id : null
    });

    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values
        };
      }
    });

    return {
      payload: returnValues,
      id: this.props.city ? this.props.city.id : null
    };
  };

  onChangeProvince = (province: Province) => {
    this.setState({
      province
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form>
        <Row>
          <Col span={12}>
            <Form.Item
              label={<FormattedMessage id="app.name" defaultMessage={`Name`} />}
            >
              {getFieldDecorator("name", {
                initialValue: this.state.name,
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.name_is_required"
                        defaultMessage={`Name is required`}
                      />
                    )
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <FormattedMessage
                  id="app.province"
                  defaultMessage={`Province`}
                />
              }
            >
              {getFieldDecorator("province_id", {
                initialValue: this.state.province
                  ? this.state.province.id
                  : null,
                rules: [
                  {
                    // whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.province_is_required"
                        defaultMessage={`Province is required`}
                      />
                    )
                  }
                ]
              })(<Input type={`hidden`} />)}
              <PovinceSingleSelection
                onChange={this.onChangeProvince}
                mode={SelectionMode.DEFAULT}
                selectedProvince={this.state.province}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}

const WrappedCityForm = Form.create({ name: "city-form" })(CityForm);

export default withFormWrapper(WrappedCityForm);
